import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  DOCUMENTS_SEARCH_FOR_DOCUMENTS: {
    en: 'Search in documents',
    de: 'In Dokumenten suchen',
  },
  DOCUMENTS_STATE: {
    en: 'State',
    de: 'Status',
  },
  DOCUMENTS_NEED_FOR_ACTION: {
    en: 'Need for action',
    de: 'Validierung notwendig',
  },
  DOCUMENTS_DELETED: {
    en: 'DELETED',
    de: 'GELÖSCHT',
  },
  DOCUMENTS_CONFIRMED: {
    en: 'Confirmed',
    de: 'Bestätigt',
  },
  DOCUMENTS_ERROR: {
    en: 'Error',
    de: 'Fehler in Verarbeitung',
  },
  DOCUMENTS_ALL_DOCUMENTS: {
    en: 'All documents',
    de: 'Alle Dokumente',
  },
  DOCUMENTS_NEW: {
    en: 'New',
    de: 'New German',
  },
  DOCUMENTS_VALIDATED: {
    en: 'Validated',
    de: 'Validiert',
  },
  DOCUMENTS_RELEASED: {
    en: 'Released',
    de: 'FREIGEGEBEN',
  },
  DOCUMENTS_DOWNLOADED: {
    en: 'Downloaded',
    de: 'HERUNTERGELADEN',
  },
  DOCUMENTS_AUTOPROCESSED: {
    en: 'Autoprocessed',
    de: 'Automatisch verarbeitet',
  },
  DOCUMENTS_SEARCH_TYPE: {
    en: 'Type',
    de: 'Suche in',
  },
  DOCUMENTS_Full_Text: {
    en: 'Full Text',
    de: 'Volltext',
  },
  DOCUMENTS_Detail_Based: {
    en: 'Detail Based',
    de: 'Merkmal',
  },
  DOCUMENTS_DETAILS: {
    en: 'Details',
    de: 'Merkmale',
  },
  DOCUMENTS_SORT_BY: {
    en: 'Sort By',
    de: 'Sortieren nach',
  },
  DOCUMENTS_CLIENT_NAME: {
    en: 'Client Name',
    de: 'Mandant',
  },
  DOCUMENTS_DATE: {
    en: 'Date',
    de: 'Datum',
  },
  DOCUMENTS_NEWEST_FIRST: {
    en: 'Newest First',
    de: 'Neueste zuerst',
  },
  DOCUMENTS_OLDEST_FIRST: {
    en: 'Oldest First',
    de: 'Älteste zuerst',
  },
  DOCUMENTS_PAGE_SIZE: {
    en: 'Page Size',
    de: 'Resultate pro Seite',
  },
  DOCUMENTS_DOCUMENTS: {
    en: 'Documents',
    de: 'Dokumente',
  },
  DOCUMENTS_OVERVIEW: {
    en: 'Overview',
    de: 'Überblick',
  },
  DOCUMENTS_CLIENT: {
    en: 'Client',
    de: 'Mandant',
  },
  DOCUMENTS_CREATED_AT: {
    en: 'Created at',
    de: 'Erstellt am',
  },
  NUMBER_OF_DOCUMENTS_SHOWN: {
    en: 'Select {count} {count, plural, one{document} other{documents}}',
    de: '{count} {count, plural, one{Dokument} other{Dokumente auswählen}}',
  },
  NUMBER_OF_DOCUMENTS_SELECTED: {
    en: 'Selected {count} {count, plural, one{document} other{documents}}',
    de: '{count} {count, plural, one{Dokument} other{Dokumente}} ausgewählt',
  },
  DOCUMENTS_DELETE_DIALOG_TITLE: {
    en: 'Are you sure that you want to delete {count, plural, one{this} other{these}} {count, plural, one{document} other{documents}}?',
    de: 'Sind sie sicher, dass sie {count, plural, one{dieses} other{diese}} {count, plural, one{Dokument} other{Dokumente}} löschen wollen?',
  },
};
